










































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetHospitals } from "@/request/hdr";
@Component({})
export default class HdrGerenxinxi extends Vue {
  @Prop()
  private message: any;
  private hospital: any = "";
  @Watch("message", { immediate: true, deep: true })
  private messageChange() {
    this.fetchHospitals();
  }

  /**
   * @description 获得所有机构列表
   */
  private fetchHospitals() {
    GetHospitals(this).then((data: any) => {
      data.forEach((hospital: any) => {
        if (hospital.hospital_id === this.message["hospital_id"]) {
          this.hospital = hospital["医院名称"];
          this.$forceUpdate();
        }
      });
    });
  }
}
